import { Link } from 'react-router-dom';

export default function BreadcrumbNav({ items }) {
    return (
        <nav aria-label="breadcrumb" className="mb-3">
            <ol className="flex items-center space-x-2 text-sm">
                {items.map((item, index) => (
                    <li key={index} className="flex items-center">
                        <span
                            className={`${
                                index === items.length - 1 
                                    ? 'text-foreground font-medium' 
                                    : 'text-muted-foreground'
                            }`}
                        >
                            {index === items.length - 1 ? (
                                item.label
                            ) : (
                                <>
                                    <Link
                                        to={item.href}
                                        className="text-primary hover:text-primary/80 hover:underline"
                                    >
                                        {item.label}
                                    </Link>
                                    <span className="mx-2 text-muted-foreground">/</span>
                                </>
                            )}
                        </span>
                    </li>
                ))}
            </ol>
        </nav>
    );
} 